<div class="ds-breadcrumb">
  <a
    *ngIf="generatedBreadcrumbs.length > 0"
    class="breadcrumb-item"
    [routerLink]="generatedBreadcrumbs[0].url"
    [queryParams]="generatedBreadcrumbs[0].queryParams"
    (click)="generatedBreadcrumbs[0].isActive && $event.preventDefault()"
    [class.active]="generatedBreadcrumbs[0].isActive"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
  >
    <ds-icon icon="home-line" class="home-icon"></ds-icon>
    <span class="label">{{ generatedBreadcrumbs[0].label }}</span>
  </a>
  <span class="separator" *ngIf="generatedBreadcrumbs.length > 1">/</span>
  <ng-container *ngFor="let item of generatedBreadcrumbs.slice(1); let i = index">
    <a
      class="breadcrumb-item"
      [routerLink]="item.url"
      [queryParams]="item.queryParams"
      (click)="item.isActive && $event.preventDefault()"
      [class.active]="item.isActive"
    >
      <span class="label">{{ item.label }}</span>
    </a>
    <span *ngIf="i < generatedBreadcrumbs.length - 2" class="separator">/</span>
  </ng-container>
</div>
